<template>
  <row class="required-labels-multiselect">
    <col3>{{ $t('train_config.add_label') }}</col3>
    <col3>
      <div v-if="selectedLabels.length" class="selected-labels">
        <v-chip
          v-for="label in selectedLabels"
          :key="labelKey(label)"
          size="small"
          closable
          class="selected-chip"
          @click:close="removeLabel(label)"
        >
          {{ label.name }}
        </v-chip>
      </div>
      <search-label-autocomplete
        :placeholder="$t('filter_tree.label_search_placeholder')"
        :prepend_icon="null"
        :clear_on_select="true"
        :disabled="disabled"
        :track_last_used="false"
        data-testid="required-labels-select"
        @label-selected="addLabel"
      />
    </col3>
  </row>
</template>

<script>
import Row from '@/components/layout/Row';
import Col3 from '@/components/layout/Col3';
import SearchLabelAutocomplete from '@/components/SearchLabelAutocomplete.vue';

export default {
  name: 'LabelMultiSelect',
  components: { Row, Col3, SearchLabelAutocomplete },
  // Declare 'change' so it is treated as a component event only. Otherwise the
  // undeclared listener falls through to the root element and native DOM `change`
  // events bubbling from the inner input would call the parent handler with a
  // DOM Event instead of our string value.
  emits: ['change'],
  props: {
    value: { default: null },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      selectedLabels: [],
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.loadFromValue(val);
      },
    },
    '$store.state.label.loaded'(loaded) {
      if (loaded) {
        this.loadFromValue(this.value);
      }
    },
  },
  mounted() {
    this.$store.dispatch('label/prefetch_all_background');
  },
  methods: {
    labelKey(label) {
      return label.id != null ? String(label.id) : label.name;
    },
    resolveLabelByName(name) {
      if (this.$store) {
        const row = (this.$store.state.label.items || []).find(
          (l) => l && l.name === name,
        );
        if (row) {
          return { id: row.id, name: row.name };
        }
      }
      return { id: name, name };
    },
    loadFromValue(val) {
      if (val == null || val === '') {
        this.selectedLabels = [];
        return;
      }
      const parts = String(val)
        .split(',')
        .map((s) => s.trim())
        .filter((s) => s !== '');
      this.selectedLabels = parts.map((name) => this.resolveLabelByName(name));
    },
    addLabel(selected) {
      if (!selected || !selected.name) {
        return;
      }
      if (this.selectedLabels.some((l) => l.name === selected.name)) {
        return;
      }
      this.selectedLabels.push({
        id: selected.id,
        name: selected.name,
      });
      this.emitValue();
    },
    removeLabel(label) {
      this.selectedLabels = this.selectedLabels.filter(
        (l) => l.name !== label.name,
      );
      this.emitValue();
    },
    emitValue() {
      const value = this.selectedLabels.map((l) => l.name).join(',');
      this.$emit('change', value);
    },
  },
};
</script>

<style scoped>
.selected-labels {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 6px;
}
.selected-chip {
  cursor: default;
}
</style>
